import React from 'react';
import './MLMNTheme.scss';

const MLMNTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-decoration-left" />
    <div className="product-hero-decoration-right" />
  </div>
);

export default MLMNTheme;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductHero/Theme/MLMN/index.js